import Tipe81 from "./tipe8 (1).webp";
import Tipe82 from "./tipe8 (2).webp";

const tipe8 = [Tipe81, Tipe82];

export default tipe8;
